import { inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { REPORT_ENDPOINTS } from '../../api/endpoints/report.endpoints';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private download = new BehaviorSubject(false);
  currentDownload = this.download.asObservable();
  private api = inject(ApiService);

  preivewReport(id: number): Observable<any> {
    return this.api.get<any>(REPORT_ENDPOINTS.V1.REPORT(id));
  }

  changeDownload(updateDownload: boolean) {
    this.download.next(updateDownload);
  }

  acceptReport(id, data): Observable<any> {
    return this.api.post(REPORT_ENDPOINTS.V1.ACCEPT_REJECT_REPORT(id), data);
  }

  generateReport(orderID): Observable<any> {
    return this.api.get<any>(REPORT_ENDPOINTS.V1.GENERATE_PDF_REPORT(orderID));
  }

  generateAlbumReport(orderID): Observable<any> {
    return this.api.get<any>(
      REPORT_ENDPOINTS.V1.GENERATE_PDF_GALLERY_REPORT(orderID),
    );
  }

  // Order Report Files API
  getOrderReportFiles(orderId: number): Observable<any> {
    return this.api.get<any>(REPORT_ENDPOINTS.V1.ORDER_REPORT_FILES(orderId));
  }

  createOrderReportFile(orderId: number, formData: FormData): Observable<any> {
    return this.api.post(
      REPORT_ENDPOINTS.V1.ORDER_REPORT_FILES(orderId),
      formData,
    );
  }

  deleteOrderReportFile(orderId: number, fileId: number): Observable<any> {
    return this.api.delete(
      REPORT_ENDPOINTS.V1.DELETE_REPORT_FILE(orderId, fileId),
    );
  }
}
